import React from 'react';
import Icon from '../../../components/AppIcon';

const CATEGORY_LIST = [
  {
    id: 'all',
    label: 'Semua Produk',
    icon: 'Grid3x3',
  },
  {
    id: 'oil',
    label: 'Oli Mesin',
    icon: 'Droplet',
  },
  {
    id: 'Pelumas',
    label: 'Pelumas',
    icon: 'Wrench',
  },
  {
    id: 'Chemical',
    label: 'Chemical',
    icon: 'FlaskConical',
  },
];

const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
      <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="Filter" size={20} color="var(--color-primary)" />
        <span>Kategori Produk</span>
      </h3>

      <div className="space-y-2">
        {CATEGORY_LIST.map((category) => {
          const isActive = activeCategory === category.id;

          return (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`w-full flex items-center space-x-3 p-3 rounded-lg text-left transition-all duration-200 ${
                isActive
                  ? 'bg-primary text-primary-foreground shadow-honda-subtle'
                  : 'bg-muted text-foreground hover:bg-primary/10 hover:text-primary'
              }`}
            >
              <Icon
                name={category.icon}
                size={18}
                color={isActive ? 'white' : 'var(--color-foreground)'}
              />
              <span className="font-heading font-semibold text-sm">
                {category.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilter;
